import axiosInstance from '../axiosInterceptor/axiosInstance'

const getGameSummary = async ({ orgId, gameId }) => {
  const url = `v1/orgs/${orgId}/stats/games/${gameId}/summary`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getGameSummary
